<button id="doc360_help_btn"
        class="shell-button"
        (click)="toggle()">
  <i class="icon icon-ic_fluent_question_circle_20_regular"></i>
</button>